export default __webpack_public_path__ + "static/media/fa-solid-900.3a909e9b.svg";